// Registers $.fn.datetimepicker against this bundle's moment, replacing the copy Voyager's
// app.js loads earlier. That copy carries a private moment with no timezone data and no way
// to reach its locale settings, so neither the time zone nor the week start can be set there.
import 'eonasdan-bootstrap-datetimepicker';
import moment from 'moment-timezone';
import { PlainObject, QueryOptions } from 'select2';

import { weekStartDay } from '../week-start';

// Lower-cased because moment's parent-locale lookup is case-sensitive and its locale files
// are named in lower case (de-AT is registered as de-at).
const locale: string = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();

// The picker has no first-day option and takes the week start from moment locale data, so
// derive a locale from the page language that only moves the first day to the tenant's week
// start. doy shifts by the same amount, which keeps the parent's week-numbering rule (which
// January day falls in week 1) unchanged.
const pickerLocale: string = locale + '-week-start';
const parentLocaleData: moment.Locale = moment.localeData(locale);
const globalLocale: string = moment.locale();
const firstDay: number = weekStartDay();
moment.defineLocale(pickerLocale, {
    parentLocale: locale,
    week: {
        dow: firstDay,
        doy: parentLocaleData.firstDayOfYear() + firstDay - parentLocaleData.firstDayOfWeek(),
    },
});
// defineLocale() also switches moment's global locale; put it back.
moment.locale(globalLocale);

const datetimepickerOptions = (): EonasdanBootstrapDatetimepicker.SetOptions => ({
    timeZone: window.app.timeZone,
    locale: pickerLocale,
});

$('.datetimepicker').datetimepicker(datetimepickerOptions());

export const onFormSubmit: (form: JQuery<HTMLFormElement>) => JQueryXHR = (
    form: JQuery<HTMLFormElement>
): JQueryXHR => {
    const response: JQueryXHR = $.ajax({
        // FormData rather than serialize(), so chosen files (image custom fields) are sent too.
        data: new FormData(form[0]),
        processData: false,
        contentType: false,
        dataType: 'json',
        type: form[0].method,
        url: form[0].action,
    });

    form.removeClass('has-errors');
    form.find('.has-error').removeClass('has-error');
    form.find('.modal-errors').empty();
    response.catch((error: JQuery.jqXHR): void => {
        if (error.responseJSON && error.responseJSON.errors) {
            for (const key in error.responseJSON.errors) {
                if (error.responseJSON.errors.hasOwnProperty(key)) {
                    // add field errors
                    const field: JQuery = form.find('[name="' + key + '"]');
                    field.parents('.form-group').addClass('has-error');

                    // add error texts
                    form.find('.modal-errors').append('<p>' + error.responseJSON.errors[key] + '</p>');
                }
            }

            form.addClass('has-errors');
        } else {
            // Any other failure (419/CSRF, 500, a network error, or a JSON payload without `errors`)
            // must still be shown — otherwise a failed submit looks like a dead, unresponsive button.
            const message: string =
                (error.responseJSON && (error.responseJSON.message || error.responseJSON.error)) ||
                error.statusText ||
                'Saving failed. Please try again.';
            form.find('.modal-errors').append('<p>' + message + '</p>');
            form.addClass('has-errors');
            // @ts-ignore - toastr is provided globally
            if (window.toastr) {
                // @ts-ignore
                window.toastr.error(message);
            }
        }
    });

    return response;
};

export const initFormFields: (element: JQuery) => void = (element: JQuery): void => {
    $('.toggleswitch').bootstrapToggle();
    $('.datetimepicker', element).datetimepicker(datetimepickerOptions());
    $('select.select2', element).select2({ width: '100%' });
    $('select.select2-ajax', element).each((index: number, selectElement: HTMLInputElement): void => {
        $(selectElement).select2({
            width: '100%',
            ajax: {
                url: $(selectElement).data('get-items-route'),
                data: (params: QueryOptions): PlainObject => ({
                    search: params.term,
                    type: $(selectElement).data('get-items-field'),
                    method: $(selectElement).data('method'),
                    id: $(selectElement).data('id'),
                    page: params.page || 1,
                }),
            },
        });
    });

    // Use event delegation and scope to the element
    element.off('click', '.js-tab').on('click', '.js-tab', (event: JQuery.ClickEvent): void => {
        event.preventDefault();
        event.stopPropagation();

        const tab: JQuery = $(event.currentTarget);
        const icon: JQuery = tab.find('i');
        const isOpen: boolean = tab.hasClass('is-open');
        const tabId: string = tab.attr('id');

        if (isOpen) {
            icon.removeClass('voyager-angle-up');
            icon.addClass('voyager-angle-down');
            // Hide fields for this tab
            element.find('[data-tab="' + tabId + '"]').addClass('hidden');
        } else {
            icon.removeClass('voyager-angle-down');
            icon.addClass('voyager-angle-up');
            // Show fields for this tab
            element.find('[data-tab="' + tabId + '"]').removeClass('hidden');
        }

        tab.toggleClass('is-open');
    });
};
